// Lightweight GA4 event helper (gtag.js loaded in index.html)
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function track(event: string, params: Record<string, unknown> = {}): void {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    } else {
      (window.dataLayer = window.dataLayer || []).push({ event, ...params });
    }
  } catch {
    /* never throw from analytics */
  }
}
